import clsx from 'clsx'
import React from 'react'
import { FormattedMessage } from 'react-intl'

import s from './styles.module.scss'

import TravelTypeButton from './travel-type-button/TravelTypeButton'
import {
  HouseOptionsFragment,
  TravelTypeEnum,
} from '../../../../../lib/graphql'
import { useTravelTypeContext } from '../../../../contexts'

interface ModalSelectProposalTravelTypeButtonGroupProps {
  houseOptions: Pick<
    HouseOptionsFragment,
    'corporateEvening' | 'studyDay' | 'nightlyTrip'
  >
  isMobile?: true
}
export const ModalSelectProposalTravelTypeButtonGroup = ({
  houseOptions: { corporateEvening, studyDay, nightlyTrip },
  isMobile,
}: ModalSelectProposalTravelTypeButtonGroupProps) => {
  const { setTravelType, travelType: selectedTravelType } =
    useTravelTypeContext()

  return (
    <div className={clsx(s.buttonGroup, { [s.buttonGroupMobile]: isMobile })}>
      <TravelTypeButton
        travelType={TravelTypeEnum.NIGHTLY_TRIP}
        isDisabled={!nightlyTrip.isEnabled}
        isSelected={selectedTravelType === TravelTypeEnum.NIGHTLY_TRIP}
        onClick={() => setTravelType(TravelTypeEnum.NIGHTLY_TRIP)}
        tooltipProps={{
          content: (
            <FormattedMessage
              id='ui.ToggleNightType.nightlyTripDisabled'
              defaultMessage="Le lieu n'accepte malheureusement pas les séjours avec nuitées"
            />
          ),
          disable: nightlyTrip.isEnabled,
          position: 'bottom',
        }}
      />
      <TravelTypeButton
        travelType={TravelTypeEnum.DAILY_TRIP}
        isDisabled={!studyDay.isEnabled}
        isSelected={selectedTravelType === TravelTypeEnum.DAILY_TRIP}
        onClick={() => setTravelType(TravelTypeEnum.DAILY_TRIP)}
        tooltipProps={{
          content: (
            <FormattedMessage
              id='ui.ToggleNightType.dailyTripDisabled'
              defaultMessage="Le lieu n'accepte malheureusement pas les séjours sans nuitées"
            />
          ),
          disable: studyDay.isEnabled,
          position: 'bottom',
        }}
      />
      <TravelTypeButton
        travelType={TravelTypeEnum.CORPORATE_EVENING_EVENT}
        isDisabled={!corporateEvening.isEnabled}
        isSelected={
          selectedTravelType === TravelTypeEnum.CORPORATE_EVENING_EVENT
        }
        onClick={() => setTravelType(TravelTypeEnum.CORPORATE_EVENING_EVENT)}
        tooltipProps={{
          content: (
            <FormattedMessage
              id='ui.ToggleNightType.corporateEveningEventDisabled'
              defaultMessage="Le lieu n'accepte malheureusement pas les soirées d'entreprise"
            />
          ),
          disable: corporateEvening.isEnabled,
          position: isMobile ? 'bottom' : 'bottom-left',
        }}
      />
    </div>
  )
}

export default ModalSelectProposalTravelTypeButtonGroup
